

<div id="st_forgot_pwd_main" class="forgot">
  <div id="st_forgot_pwd_bg_decor" class="auth-bg-decor" aria-hidden="true">
    <div class="auth-bg-glow"></div>
    <div class="auth-bg-dots"></div>
    <svg class="auth-bg-waves" viewBox="0 0 400 240" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="authWaveGradientForgot1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" class="auth-wave-stop-start-1" />
          <stop offset="100%" class="auth-wave-stop-end" />
        </linearGradient>
        <linearGradient id="authWaveGradientForgot2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" class="auth-wave-stop-start-2" />
          <stop offset="100%" class="auth-wave-stop-end" />
        </linearGradient>
        <linearGradient id="authWaveGradientForgot3" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" class="auth-wave-stop-start-3" />
          <stop offset="100%" class="auth-wave-stop-end" />
        </linearGradient>
      </defs>
      <path class="auth-wave-fill-1"
        d="M-20 150 C 40 120, 90 170, 150 145 C 210 120, 260 165, 320 140 C 360 122, 390 132, 420 150 L 420 240 L -20 240 Z"
        fill="url(#authWaveGradientForgot1)" />
      <path class="auth-wave-fill-2"
        d="M-20 172 C 45 148, 95 190, 155 168 C 215 146, 265 185, 325 165 C 365 150, 392 158, 420 172 L 420 240 L -20 240 Z"
        fill="url(#authWaveGradientForgot2)" />
      <path class="auth-wave-fill-3"
        d="M-20 196 C 50 175, 100 210, 160 192 C 220 174, 270 208, 330 190 C 368 176, 394 182, 420 196 L 420 240 L -20 240 Z"
        fill="url(#authWaveGradientForgot3)" />
      <path class="auth-wave-line"
        d="M-20 168 C 45 144, 95 186, 155 164 C 215 142, 265 181, 325 161 C 365 146, 392 154, 420 168" />
      <path class="auth-wave-line auth-wave-line-2"
        d="M-20 190 C 50 169, 100 204, 160 186 C 220 168, 270 202, 330 184 C 368 170, 394 176, 420 190" />
    </svg>
  </div>
  <div id="st_forgot_pwd_header" class="auth-wave-header gap-2 d-flex align-items-center"
    [class.collapsed-header]="activeIndex > 0"
    [ngClass]="_forgotForm.get('password')?.value ? 'refract-view' : 'forgot-password-view'">
    <div id="st_forgot_pwd_brand" class="brand_img">
      <img *ngIf="!is_dark" [src]="loginSidebarLogoLight" alt="logo_dark"
        [width]="tenant_name == 'switz' ? '254' : (tenant_name == 'sbtf' ? '130' : '150')" />
      <img *ngIf="is_dark" [src]="logo_light" alt="logo_dark"
        [width]="tenant_name == 'switz' ? '254' : (tenant_name == 'sbtf' ? '130' : '150')" />
    </div>
    <button type="button" class="auth-close-btn" (click)="closeDialog()" [attr.aria-label]="'close' | translate">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>



  <div id="st_forgot_pwd_steps_container" class="steps_container" [ngClass]="{
    'step-1-active': activeIndex === 0,
    'step-2-active': activeIndex === 1,
    'step-3-active': activeIndex === 2
  }">
    <p class="login-welcome-title fs-32 fw-bold mb-0">
      {{ 'forgot_password_title' | translate }} <span class="login-welcome-accent">{{ 'forgot_password_title_accent' |
        translate }}</span>
    </p>
    <p class="login-welcome-subtitle fs-14 fw-normal mt-1 mb-2">{{ 'forgot_password_subtitle' | translate }}</p>
    <p-stepper [(activeStep)]="activeIndex" [linear]="true">
      <p-stepperPanel [header]="'Sent OTP'|translate">
        <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
          <!-- Step 1: Email Input -->
          <form [formGroup]="_emailForm" (ngSubmit)="sendOtp()">
            <div id="st_forgot_pwd_email_container" class="email">
              <h4 class="fs-13 fw-semibold">{{'Email'|translate}}</h4>
              <div id="st_forgot_pwd_email_input_wrap" class="my-2 email_input">
                <input type="email" pInputText formControlName="email" [placeholder]="'example_email_com'|translate"
                  [class.ng-invalid]="_emailForm.get('email')?.invalid && _emailForm.get('email')?.touched"
                  [class.ng-valid]="_emailForm.get('email')?.valid && _emailForm.get('email')?.touched" />
              </div>
              <div id="st_forgot_pwd_email_err" class="error-messages mt-2"
                *ngIf="_emailForm.get('email')?.invalid && _emailForm.get('email')?.touched">
                <small class="text-danger d-block fs-12 mb-1" *ngIf="_emailForm.get('email')?.errors?.['required']">
                  {{'email_is_required'|translate}}
                </small>
                <small class="text-danger d-block fs-12 mb-1" *ngIf="_emailForm.get('email')?.errors?.['email']">
                  {{'please_enter_a_valid_email_address'|translate}}
                </small>
              </div>
              <div id="st_forgot_pwd_email_note" class="mt-3 gap-2 p-3 forgot-email-note">
                <i class="bi bi-info-circle fs-14"></i>
                <small class="fs-14 fw-normal">{{'forgot_password_email_note'|translate}}</small>
              </div>
              <div id="st_forgot_pwd_email_btn_wrap" class="mt-4 text-center">
                <button type="submit" class="send_btn fs-13 fw-semibold py-2 px-4"
                  [disabled]="_emailForm.get('email')?.invalid || _isSubmit">
                  {{ _isSubmit ? ('Send_OTP'|translate) : ('Send_OTP'|translate) }}
                </button>
              </div>
            </div>
          </form>
        </ng-template>
      </p-stepperPanel>

      <p-stepperPanel [header]="'Verify_OTP'|translate">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback"
          let-index="index">
          <!-- Step 2: OTP Verification -->
          <div id="st_forgot_pwd_otp_ver" class="otp-verification">
            <!-- Email Display as Input Field -->
            <div id="st_forgot_pwd_email_disp" class="my-2 email-display">
              <h4 class="fs-13 fw-semibold auth-muted-text">{{'Email'|translate}}</h4>
              <div id="st_forgot_pwd_email_input_ro" class="my-2 email_input">
                <input type="email" pInputText [value]="_emailForm.get('email')?.value"
                  [placeholder]="'Email'|translate" readonly class="readonly-email" />
              </div>
            </div>
            <h4 class="mt-4 fs-13 fw-semibold auth-muted-text text-capitalize">{{'Verify_OTP_Full'|translate}}</h4>
            <div id="otpinputs" class="my-4">
              <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config" inputClass="otpFixed">
              </ng-otp-input>
            </div>

            <!-- OTP inline info banner -->
            <div id="st_forgot_pwd_timer_wrap" class="otp-info-banner mb-3"
              [class.otp-info-banner--warning]="isOtpCountdownActive() && timer <= 30"
              [class.otp-info-banner--expired]="isOtpExpired()" [class.otp-info-banner--resending]="_isResendingOtp"
              *ngIf="_startCountdown || _isResendingOtp">
              @if (isOtpExpired()) {
              <div class="otp-info-banner__expired d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex align-items-start gap-2 min-w-0">
                  <span class="otp-info-banner__icon-wrap otp-info-banner__icon-wrap--expired" aria-hidden="true">
                    <i class="bi bi-exclamation-circle otp-info-banner__icon otp-info-banner__icon--expired"></i>
                  </span>
                  <div class="min-w-0">
                    <p class="mb-0 fs-14 fw-semibold otp-info-banner__expired-title">
                      {{ 'otp_verification_code_expired' | translate }}
                    </p>
                    <p class="mb-0 fs-13 otp-info-banner__expired-message">
                      {{ 'otp_expired_support_message' | translate }}
                    </p>
                  </div>
                </div>

                <button type="button" id="otpSender"
                  class="otp-info-banner__resend fs-13 fw-medium flex-shrink-0 d-inline-flex align-items-center gap-1"
                  [disabled]="_isResendingOtp" (click)="resendOtp()" [attr.aria-label]="'resend_now' | translate">
                  @if (_isResendingOtp) {
                  <span class="otp-info-banner__spinner otp-info-banner__spinner--inline" aria-hidden="true"></span>
                  <span>{{ 'otp_resending' | translate }}</span>
                  } @else {
                  <i class="bi bi-arrow-repeat otp-info-banner__resend-icon" aria-hidden="true"></i>
                  <span>{{ 'resend_now' | translate }}</span>
                  }
                </button>
              </div>
              } @else {
              <div class="otp-info-banner__body d-flex flex-column">
                <div class="otp-info-banner__head d-flex align-items-start gap-2 min-w-0">
                  <span class="otp-info-banner__icon-wrap" aria-hidden="true">
                    <i class="bi bi-envelope otp-info-banner__icon"></i>
                  </span>
                  <div class="min-w-0">
                    <p class="mb-0 fs-14 fw-medium otp-info-banner__title">
                      {{ 'otp_verification_sent_title' | translate }}
                    </p>
                    <p class="mb-0 fs-13 otp-info-banner__email text-truncate">
                      {{ 'otp_delivered_to' | translate }} {{ getMaskedEmail() }}
                    </p>
                  </div>
                </div>

                <div
                  class="otp-info-banner__utility d-flex align-items-center justify-content-between gap-2 min-w-0 mt-1">
                  <div class="d-flex align-items-center gap-2 min-w-0">
                    @if (_isResendingOtp) {
                    <span class="otp-info-banner__spinner" aria-hidden="true"></span>
                    <span class="fs-13 fw-medium otp-info-banner__timer">{{ 'otp_sending_new_code' | translate }}</span>
                    } @else {
                    <span class="otp-info-banner__icon-wrap otp-info-banner__icon-wrap--utility" aria-hidden="true">
                      <i class="bi bi-clock otp-info-banner__icon"></i>
                    </span>
                    <span class="fs-13 fw-medium otp-info-banner__timer">
                      <span class="otp-info-banner__timer-label">{{ 'otp_expires_in' | translate }}</span>
                      <span class="otp-info-banner__timer-value fw-bold">{{ formatOtpTimer() }}</span>
                    </span>
                    }
                  </div>

                  <button type="button" id="otpSender"
                    class="otp-info-banner__resend fs-13 fw-medium flex-shrink-0 d-inline-flex align-items-center gap-1"
                    [disabled]="_isResendingOtp" (click)="resendOtp()" [attr.aria-label]="'resend_now' | translate">
                    @if (_isResendingOtp) {
                    <span class="otp-info-banner__spinner otp-info-banner__spinner--inline" aria-hidden="true"></span>
                    <span>{{ 'otp_resending' | translate }}</span>
                    } @else {
                    <i class="bi bi-arrow-repeat otp-info-banner__resend-icon" aria-hidden="true"></i>
                    <span>{{ 'resend_now' | translate }}</span>
                    }
                  </button>
                </div>

                <div class="otp-info-banner__track" role="progressbar" [attr.aria-valuenow]="timer"
                  [attr.aria-valuemin]="0" [attr.aria-valuemax]="otpTimerDuration"
                  [attr.aria-label]="('otp_expires_in' | translate) + ' ' + formatOtpTimer()">
                  <div class="otp-info-banner__progress" [class.otp-info-banner__progress--loading]="_isResendingOtp"
                    [style.width.%]="getOtpTimerProgress()"></div>
                </div>
              </div>
              }
            </div>

            <div id="st_forgot_pwd_otp_btn_wrap" class="mt-4 d-flex justify-content-between">
              <button type="button" class="send_btn fs-13 fw-semibold py-2 px-4 text-capitalize" (click)="verifyOTP()"
                [disabled]="_currentOTP.length != config.length" (keydown.enter)="verifyOTP()" (keydown.space)="$event.preventDefault(); verifyOTP()" tabindex="0">
                {{ 'Verify_OTP_Full'|translate }}
              </button>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <p-stepperPanel [header]="'change_pwd'|translate">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index">
          <!-- Step 3: Change Password -->
          <form [formGroup]="_forgotForm" (ngSubmit)="changePassword()" class="password-change mt-3">
            <div id="st_forgot_pwd_new_pass_wrap" class="my-3 password_input">
              <label class="form-label fs-13 fw-semibold" for="st_forgot_pwd_new_pass">{{'new_password'|translate}}</label>
              <div id="st_forgot_pwd_new_pass_rel" class="relativePass">
                <input id="st_forgot_pwd_new_pass" [type]="passwordFieldType" pInputText formControlName="password"
                  [placeholder]="'enter_new_password'|translate"
                  [class.criteria-attached-field]="_forgotForm.get('password')?.value"
                  [class.ng-invalid]="_forgotForm.get('password')?.invalid && _forgotForm.get('password')?.touched"
                  [class.ng-valid]="_forgotForm.get('password')?.valid && _forgotForm.get('password')?.touched" />
                <div id="st_forgot_pwd_new_pass_eye" class="eyeIconContainer">
                  <button type="button" class="st-btn-unstyled"
                    (click)="togglePasswordVisibility()"><i class="bi fs-14"
                      [class.bi-eye]="passwordFieldType === 'password'"
                      [class.bi-eye-slash]="passwordFieldType === 'text'"></i></button>
                </div>
              </div>

              <!-- Password Criteria List -->
              <div id="st_forgot_pwd_pass_criteria" class="password_input" *ngIf="_forgotForm.get('password')?.value">
                <div class="password-criteria">
                  <ul class="criteria-list">
                    <li class="d-flex align-items-center gap-1 fs-12" [class.criteria-met]="isPasswordUppercaseValid()"
                      [class.criteria-not-met]="!isPasswordUppercaseValid()">
                      <i class="bi fs-13" [class.bi-check-circle-fill]="isPasswordUppercaseValid()"
                        [class.bi-x-circle-fill]="!isPasswordUppercaseValid()"></i>
                      {{ 'A-Z' }}
                    </li>
                    <li class="d-flex align-items-center gap-1 fs-12" [class.criteria-met]="isPasswordNumberValid()"
                      [class.criteria-not-met]="!isPasswordNumberValid()">
                      <i class="bi fs-13" [class.bi-check-circle-fill]="isPasswordNumberValid()"
                        [class.bi-x-circle-fill]="!isPasswordNumberValid()"></i>
                      {{ '0-9' }}
                    </li>
                    <li class="d-flex align-items-center gap-1 fs-12" [class.criteria-met]="isPasswordSpecialValid()"
                      [class.criteria-not-met]="!isPasswordSpecialValid()">
                      <i class="bi fs-13" [class.bi-check-circle-fill]="isPasswordSpecialValid()"
                        [class.bi-x-circle-fill]="!isPasswordSpecialValid()"></i>
                      {{ '@#$%' }}
                    </li>
                    <li class="d-flex align-items-center gap-1 fs-12" [class.criteria-met]="isPasswordLengthValid()"
                      [class.criteria-not-met]="!isPasswordLengthValid()">
                      <i class="bi fs-13" [class.bi-check-circle-fill]="isPasswordLengthValid()"
                        [class.bi-x-circle-fill]="!isPasswordLengthValid()"></i>
                      {{ '8+ chars' }}
                    </li>
                  </ul>
                  <p class="text-muted fs-12 mt-1 fw-medium">{{ 'example' | translate }}: {{ 'Test@1234' }}</p>
                </div>
              </div>

              <div id="st_forgot_pwd_new_pass_err" class="error-messages mt-2"
                *ngIf="_forgotForm.get('password')?.invalid && _forgotForm.get('password')?.touched">
                <small class="text-danger d-block fs-12 mb-1" *ngIf="_forgotForm.get('password')?.errors?.['required']">
                  {{'password_is_required'|translate}}
                </small>
                <small class="text-danger d-block fs-12 mb-1" *ngIf="_forgotForm.get('password')?.errors?.['pattern']">
                  {{'password_must_meet_all_criteria_above'|translate}}
                </small>
              </div>
            </div>

            <div id="st_forgot_pwd_conf_pass_wrap" class="my-3 password_input">
              <label class="form-label fs-13 fw-semibold" for="st_forgot_pwd_conf_pass">{{'Confirm_password'|translate}}</label>
              <div id="st_forgot_pwd_conf_pass_rel" class="relativePass">
                <input id="st_forgot_pwd_conf_pass" [type]="passwordFieldType1" pInputText formControlName="confirmPassword"
                  [placeholder]="'confirm_new_password'|translate"
                  [class.ng-invalid]="_forgotForm.get('confirmPassword')?.invalid && _forgotForm.get('confirmPassword')?.touched"
                  [class.ng-valid]="_forgotForm.get('confirmPassword')?.valid && _forgotForm.get('confirmPassword')?.touched" />
                <div id="st_forgot_pwd_conf_pass_eye" class="eyeIconContainer">
                  <button type="button" class="st-btn-unstyled"
                    (click)="togglePasswordVisibility1()"><i class="bi fs-14"
                      [class.bi-eye]="passwordFieldType1 === 'password'"
                      [class.bi-eye-slash]="passwordFieldType1 === 'text'"></i></button>
                </div>
              </div>

              <!-- Password Match Validation -->
              <div id="st_forgot_pwd_pass_match_wrap" class="mt-2 password-match"
                *ngIf="_forgotForm.get('confirmPassword')?.value">
                <div id="st_forgot_pwd_pass_match_ind" [class.criteria-met]="isPasswordMatch()"
                  [class.criteria-not-met]="!isPasswordMatch()"
                  class="match-indicator d-flex align-items-center gap-1 fs-12">
                  <i class="bi fs-13" [class.bi-check-circle-fill]="isPasswordMatch()"
                    [class.bi-x-circle-fill]="!isPasswordMatch()"></i>
                  {{ isPasswordMatch() ? ('password_match'|translate) : ('password_do_not_match'|translate) }}
                </div>
              </div>

              <div id="st_forgot_pwd_conf_pass_err" class="error-messages mt-2"
                *ngIf="_forgotForm.get('confirmPassword')?.invalid && _forgotForm.get('confirmPassword')?.touched">
                <small class="text-danger d-block fs-12 mb-1"
                  *ngIf="_forgotForm.get('confirmPassword')?.errors?.['required']">
                  {{'confirm_password_is_required'|translate}}
                </small>
              </div>
            </div>

            <div id="st_forgot_pwd_submit_wrap" class="mt-4 d-flex justify-content-between">

              <button type="submit" class="send_btn fs-13 fw-semibold py-2 px-4"
                [disabled]="!_forgotForm.get('password')?.value || !_forgotForm.get('confirmPassword')?.value || !isAllPasswordCriteriaMet() || !isPasswordMatch() || _isSubmited">
                {{ _isSubmited ? ('updating_password'|translate) : ('update_password'|translate) }}
              </button>
            </div>
          </form>
        </ng-template>
      </p-stepperPanel>
    </p-stepper>
  </div>
</div>